import { useSelector } from 'react-redux';

import type { RootState } from '../../../../../../../store';

export default function useIntakeTherapyPageState() {
  const therapies = useSelector(
    (state: RootState) => state.intakeQuestionnaire.intakeQuestionnaireDetails?.therapies ?? [],
  );
  const hasNoTherapies = useSelector(
    (state: RootState) =>
      state.intakeQuestionnaire.intakeQuestionnaireDetails?.has_no_therapies ?? false,
  );
  const isSaving = useSelector(
    (state: RootState) =>
      state.intakeQuestionnaire.createTherapyLoading ||
      state.intakeQuestionnaire.updateTherapyLoading ||
      state.intakeQuestionnaire.deleteTherapyLoading ||
      state.intakeQuestionnaire.deleteAllTherapiesLoading ||
      state.intakeQuestionnaire.setHasNoTherapiesLoading,
  );
  // The bulk operations (delete all / toggle "no historical therapy") must lock the checkbox
  // and list fields and hold the confirm dialog open, so they are exposed on their own rather
  // than only feeding the list progress bar via `isSaving`.
  const isBulkSaving = useSelector(
    (state: RootState) =>
      state.intakeQuestionnaire.deleteAllTherapiesLoading ||
      state.intakeQuestionnaire.setHasNoTherapiesLoading,
  );

  return { therapies, hasNoTherapies, isSaving, isBulkSaving };
}
